import React from 'react'

function DashboardSection() {
  return (
    <div>DashboardSection</div>
  )
}

export default DashboardSection